import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { actions } from '../Chart.redux';
import {
    FilteringState,
    IntegratedFiltering,
    IntegratedPaging,
    IntegratedSorting,
    PagingState,
    SortingState,
} from '@devexpress/dx-react-grid';
import { Grid, PagingPanel, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import AllSymbolsDialogCell from 'pages/Chart/ChartingMenu/components/AllSymbolsDialogCell';

const defaultSymbols = [];

const AllSymbolsDialog = () => {
    const dispatch = useDispatch(),
        showDialog = useSelector((state) => state.chart.toolbar.showAllSymbolsDialog),
        symbols = useSelector((state) => state.chart.symbols) || defaultSymbols,
        [columns] = useState([
            { name: 'symbol_abbreviation', title: 'Abbreviation', width: 100 },
            { name: 'symbol_category', title: 'Category' },
            { name: 'symbol_name', title: 'Name' },
        ]),
        [columnExtensions] = useState([
            { columnName: 'symbol_abbreviation', width: 150 },
            { columnName: 'symbol_category', width: 150 },
        ]);

    const handleClose = () => dispatch(actions.setToolbar({ showAllSymbolsDialog: false }));

    return (
        <Dialog fullWidth={true} maxWidth="lg" open={showDialog} onClose={handleClose}>
            <DialogTitle>All Codes</DialogTitle>

            <DialogContent>
                <Grid rows={symbols} columns={columns}>
                    <FilteringState defaultFilters={[]} />
                    <IntegratedFiltering />

                    <SortingState defaultSorting={[{ columnName: 'symbol_abbreviation', direction: 'asc' }]} />
                    <IntegratedSorting />

                    <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                    <IntegratedPaging />

                    <Table columnExtensions={columnExtensions} cellComponent={AllSymbolsDialogCell} />
                    <TableHeaderRow showSortingControls />

                    <PagingPanel pageSizes={[10, 20, 50, 100]} />

                    <TableFilterRow />
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AllSymbolsDialog;
